// src/utils/datePresets.js
//
// The date buttons the report screens open on.
//
// One list, because two report screens offering "Last 3 Months" and meaning
// two different spans is the kind of difference nobody notices until the two
// reports are put side by side and disagree.
import { startOfMonth, endOfMonth, subMonths, subDays } from "date-fns";

/* The date buttons on the setup screen.
 *
 * Presets rather than a calendar because a report is almost always asked for
 * over a named period — yesterday, this month, the last quarter — and picking
 * "this month" out of a two-month grid means knowing today's date, finding the
 * first, and clicking twice. `range()` returns the pair; `isSameDay` on both
 * ends is what lights the button back up when you return to the screen.
 *
 * The from/to boxes are still there for the tenth case the buttons miss. */
export const DATE_PRESETS = [
  {
    key: "today",
    label: "Today",
    icon: "bi-calendar-day",
    range: () => {
      const t = new Date();
      return { startDate: t, endDate: t };
    },
  },
  {
    key: "yesterday",
    label: "Yesterday",
    icon: "bi-clock-history",
    range: () => {
      const y = subDays(new Date(), 1);
      return { startDate: y, endDate: y };
    },
  },
  {
    key: "month",
    label: "This Month",
    icon: "bi-calendar3",
    range: () => ({ startDate: startOfMonth(new Date()), endDate: new Date() }),
  },
  {
    key: "lastmonth",
    label: "Last Month",
    icon: "bi-calendar-event",
    /* A finished month, both ends — the only preset here that does not run to
       today, because "last month" is a closed period and a report of it that
       stopped on the 20th would be wrong rather than merely short. */
    range: () => {
      const prev = subMonths(new Date(), 1);
      return { startDate: startOfMonth(prev), endDate: endOfMonth(prev) };
    },
  },
  {
    key: "3months",
    label: "Last 3 Months",
    icon: "bi-calendar-range",
    range: () => ({
      startDate: startOfMonth(subMonths(new Date(), 2)),
      endDate: new Date(),
    }),
  },
  {
    key: "6months",
    label: "Last 6 Months",
    icon: "bi-calendar-range",
    range: () => ({
      startDate: startOfMonth(subMonths(new Date(), 5)),
      endDate: new Date(),
    }),
  },
];
